//CorpConsoleHome.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandsHelping, faBookOpen, faShoppingCart, faGifts, faRainbow, faClock, faChartLine, faVideo, faCalendarAlt, faCloud, faExclamationTriangle, faUserShield, faBuilding } from '@fortawesome/free-solid-svg-icons';
import './CorpConsole.css';
import corpconsoleimage from '../../assets/pageimages/CorpConsole.webp';

function CorpConsoleHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>CorpConsole</h2>
      </div>
      <div className="main-content">
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-department" className="top-button-link">
                <FontAwesomeIcon icon={faBuilding} className="corpconsole-bottomlink-style" />
                Department
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-employee" className="top-button-link">
                <FontAwesomeIcon icon={faHandsHelping} className="corpconsole-bottomlink-style" />
                Employee
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-bookshelf" className="top-button-link">
                <FontAwesomeIcon icon={faBookOpen} className="corpconsole-bottomlink-style" />
                BookShelf
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-skill-development" className="top-button-link">
                <FontAwesomeIcon icon={faShoppingCart} className="corpconsole-bottomlink-style" />
                Skill Development
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-certificate-earners" className="top-button-link">
                <FontAwesomeIcon icon={faGifts} className="corpconsole-bottomlink-style" />
                Certificate Earners
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-relearn" className="top-button-link">
                <FontAwesomeIcon icon={faRainbow} className="corpconsole-bottomlink-style" />
                Relearn
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-focus-timer-activities" className="top-button-link">
                <FontAwesomeIcon icon={faClock} className="corpconsole-bottomlink-style" />
                Focus Timer Activities
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-focus-timer-insight" className="top-button-link">
                <FontAwesomeIcon icon={faChartLine} className="corpconsole-bottomlink-style" />
                Focus Timer Insight
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-workshop" className="top-button-link">
                <FontAwesomeIcon icon={faVideo} className="corpconsole-bottomlink-style" />
                Workshop
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-training-schedule" className="top-button-link">
                <FontAwesomeIcon icon={faCalendarAlt} className="corpconsole-bottomlink-style" />
                Training Schedule
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-rca-cloud" className="top-button-link">
                <FontAwesomeIcon icon={faCloud} className="corpconsole-bottomlink-style" />
                RCA Cloud
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-problem-insights" className="top-button-link">
                <FontAwesomeIcon icon={faExclamationTriangle} className="corpconsole-bottomlink-style" />
                Problem Insights
              </Link>
            </div>
            <div className="bottom-buttons-box">
              <Link to="/corpconsole-decision-support" className="top-button-link">
                <FontAwesomeIcon icon={faUserShield} className="corpconsole-bottomlink-style" />
                Decision Support
              </Link>
            </div>
          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="corpconsole-id" src={corpconsoleimage} alt="CorpConsole Image" />
          </div>
        </div>
      </div>
     </div>
    </MainLayout>
  );
}

export default CorpConsoleHome;
